import React from 'react';
import { Button, Input, Space, message } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import constant from "constants/constant";
import moment from 'moment';

const util = {
  displayApiError: (err) => {
    message.error(err?.message ?? constant.text.err500);
  },

  isInMenu: (menuList, path) => {
    for (let i = 0; i < menuList.length; i++) {
      if(menuList[i].url?.toLowerCase() === path){
        return true;
      }
      if(util.isInMenu(menuList[i].child, path)){
        return true;
      }
    }
    
    return false;
  },

  getCurrentUrlDetail: () => {
    const pathSplit = window.location.pathname.split('/');
    const urlParams = new URLSearchParams(window.location.search);

    return {
      host: window.location.host,
      path: pathSplit.length > 1 ? pathSplit[1].toLowerCase() : null,
      subPath: pathSplit.length > 2 ? pathSplit[2].toLowerCase() : null,
      id: urlParams.get('id'),
      marginType: urlParams.get('marginType')
    }
  },

  isIn: (src, arr) => {
    return arr.some(a => (a ?? '').toLowerCase() === (src ?? '').toLowerCase());
  },

  getPagePermission: (page, pageAccess) => {
    const allowCreate = pageAccess.some(a => a.accessId.toLowerCase() === `create${page}` && a.allowed);
    const allowUpdate = pageAccess.some(a => a.accessId.toLowerCase() === `update${page}` && a.allowed);
    const allowDelete = pageAccess.some(a => a.accessId.toLowerCase() === `delete${page}` && a.allowed);
    const allowResetPassword = pageAccess.some(a => a.accessId.toLowerCase() === `resetpassworduser` && a.allowed);
    const allowChangeActiveStatus = pageAccess.some(a => a.accessId.toLowerCase() === `changeactivestatus` && a.allowed);
    const allowUnlock = pageAccess.some(a => a.accessId.toLowerCase() === `unlockuser` && a.allowed);

    return {
      allowCreate,
      allowUpdate,
      allowDelete,
      allowResetPassword,
      allowChangeActiveStatus,
      allowUnlock
    }
  },

  isAuthorized: (page, permission) => {
    if(page === constant.path.detail) return permission.allowUpdate;
    if(page === constant.path.create) return permission.allowCreate;

    return true;
  },

  formatThousand: (number = 0) => {
    const thousand = new Intl.NumberFormat();
    return thousand.format(number);
  },

  formatTitleCase: (words) => {
    const text = words
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");
    return text;
  },

  formatNullableDatetime: (dt) => {
    if(!dt || !moment.utc(dt).isValid() ) return '---';

    return moment.utc(dt).format('YYYY-MM-DD HH:mm:ss');
  },
  isNullOrEmpty: (src) => {
    return src == null || src === '';
  },
  isNullOrWhiteSpace: (value) => {
    return value == null || value == undefined || value.trim() === "";
  },

  getColumnSearchProps: (dataIndex, searchInput, isDateType) => {
    return ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div
          style={{
            padding: 8,
          }}
        >
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => { confirm({ closeDropdown: true }); }}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => { confirm({ closeDropdown: true }); }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 100,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                if (clearFilters)
                  clearFilters();
                confirm({ closeDropdown: true });
              }
              }
              size="small"
              style={{
                width: 100,
              }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      onFilter: (value, record) => {
        if (isDateType)
          return util.formatNullableDatetime(`${record[dataIndex]}`).toLowerCase().includes(value.toLowerCase());
        else
          return `${record[dataIndex]}`.toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    })
  }
}

export default util;